import { createFileRoute, Link } from '@tanstack/react-router'
import Opportunity from '@/views/opportunity'
import { opportunities, useOpportunityData } from '@/opportunity/api'
import { usePosthogGroup } from '@/posthog/usePosthogGroup'

export const Route = createFileRoute(
  '/_authenticated/organization/$organizationId/_non_installer/issues/$opportunityId',
)({
  component: RouteComponent,
  beforeLoad: () => ({ removeContentPadding: true }),
  params: {
    parse: (rawParams) => ({
      opportunityId: parseInt(rawParams.opportunityId),
    }),
  },
  loader: ({ context: { queryClient }, params: { opportunityId } }) =>
    queryClient.ensureQueryData(opportunities.detail(opportunityId)),
  staticData: {
    breadcrumb: Breadcrumb,
  },
})

function RouteComponent() {
  const { data: opportunity } = useOpportunityData()

  usePosthogGroup('issue', opportunity, { clearOnUnmount: true })

  return <Opportunity />
}

function Breadcrumb() {
  const { data: opportunity } = useOpportunityData()
  return (
    <Link to={Route.fullPath} params={Route.useParams()}>
      {opportunity.name}
    </Link>
  )
}
